// ** Logo
import logo from '@src/assets/images/logo/axentra_logo.png'

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner app-loader'>
      <img
        src={logo}
        alt="logo"
        style={{ width: "36px", height: "auto", objectFit: "contain" }}
      />

      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
